module.exports = __webpack_public_path__ + "img/31 robot loly.ee01b10b.jpg";